export enum GlobalEventType {
    ErrorOccurred = "ERROROCCURRED",
    Notified = "NOTIFIED",
    GetFeedback = "GETFEEDBACK",
}
